import { render, staticRenderFns } from "./electric-charge-bill.vue?vue&type=template&id=5970a2b0&scoped=true&"
import script from "./electric-charge-bill.vue?vue&type=script&lang=js&"
export * from "./electric-charge-bill.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-bill.vue?vue&type=style&index=0&id=5970a2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970a2b0",
  null
  
)

export default component.exports